// Legacy offering entry routes redirect to the complete service editor.
export { default } from "./form";
